import { render, staticRenderFns } from "./jumbo.vue?vue&type=template&id=7267ff36&scoped=true"
import script from "./jumbo.vue?vue&type=script&lang=js"
export * from "./jumbo.vue?vue&type=script&lang=js"
import style0 from "./jumbo.vue?vue&type=style&index=0&id=7267ff36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267ff36",
  null
  
)

export default component.exports